<template>
	<div class="family_detail_index">
        <div class="family_detail_header">
          <mVideo
              :videoUrl="itemDetail.mediaurl"
              v-if="itemDetail.mediaurl"
              height="4rem"
              fit="contain"
          ></mVideo>
          <vanImage :src="itemDetail.icon" style="width: 7.5rem;height:3.74rem;" v-else></vanImage>
<!--            <div class="guze" @click="ticket">兑奖规则 ></div>-->
<!--            <div class="family_detail_index_header_btn">-->
<!--                <div class="mvbutton continue " @click="signup" v-if="today_state==0">-->
<!--                    我要参赛-->
<!--                </div>-->
<!--                <div class="mvbutton old" v-else>-->
<!--                    已参赛-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="family_time">-->
<!--                <div class="family_detail_index_header_notice">上传说明：上传视频在200MB以内（30~60秒）<span @click="rule">参赛办法</span></div>-->
<!--            </div>-->
        </div>
		<div class="family_detail_index_body">
			<div class="family_detail_index_body_btn">
				<div class="family_detail_index_body_btn_left">
					<div :class="['mvbutton', type==1?'selected':'default']" @click="goType(1)">
              全部选手
          </div>
				</div>
				<div class="family_detail_index_body_btn_right">
					<div :class="['mvbutton', type==2?'selected':'default']" @click="goType(2)">
              投票排行
          </div>
				</div>
			</div>
			<div class="family_detail_index_body_item">
				<template v-if="type==1">
                    <div class="family_detail_index_body_search">
                        <form action="/">
                            <van-search v-model="keyword" shape="round" background="transparent" @search="onSearch" placeholder="请输入关键词" />
                        </form>
                        <div class="mvbutton search" @click="search">
                            查询
                        </div>
                    </div>
					<VoteList v-bind:keyword="keyword" v-bind:itemid="item_sub_id"  v-bind:sportsid="sports_id" v-on:goVote="goVote" v-on:goVideo="goVideo"></VoteList>
				</template>
				<template v-else>
					<RankList  v-bind:itemid="item_sub_id"></RankList>
				</template>
			</div>
		</div>
	</div>
</template>
<script>
    import './index.less'
    import { Image, Overlay,Search } from 'vant';
    import mVideo from "@/components/mVideo/index";
    import VoteList from '@/components/VoteList'
    import RankList from '@/components/RankList'
    import { mapGetters, mapMutations } from "vuex";
    export default {
      props: ["item_sub_id", "sports_id"],
        data(){
          return {
            showrule:false,
            type:1,
            codeurl:'https://www.baidu.com',
            dataURL:'',
            firstFlag:false,
            today_state:1,
            starttime:'',
            endtime:'',
            votestarttime:'',
            id:'',
            keyword:'',
            itemDetail: {}
          }
        },
        components:{
          vanOverlay:Overlay,
          vanImage:Image,
        	VoteList,
        	RankList,
          vanSearch:Search,
          mVideo
        },
        methods:{
          ...mapMutations(["toggleShowFill"]),
            goType(type){
                this.type = type
            },
            goback(){
            	this.$router.go(-1);
            },
            signup(){
            	this.$router.push({name:'familysignup'})
            },
            goVote(val){
                this.$router.push({name:'vote',params:{vcid:val.vcid, today_state:this.today_state}})
            },
          init(){
            let params = { cpgid: this.item_sub_id };
            this.$api.sports.getComparegame(params).then((res)=>{
                  if(res.status*1===200){
                    this.today_state = res.data.today_state;
                    this.itemDetail = res.data
                  }
              })
            },
            goVideo(item) {
                this.$router.push({name:'video',params:{mediaurl:item.mediaurl,imgurl:item.imgurl}})
            },
            ticket() {
                this.$router.push({name:'ticket',params:{type:1}})
            },
            rule() {
                this.$router.push({name:'ticket',params:{type:2}})
            },
            onSearch(val) {
                console.log(this.keyword)
            },
            search(){
                console.log(this.keyword,111)
            }
        },
        mounted(){
          this.init();
          this.cf.wxShareConf();
        }
    }
</script>
